<template lang="pug">
.mov-alert-headup(v-if="unreached.length")
  .header
    .icon
      i.bx.bxs-dollar-circle
    .info
      .title Minimum order value is not met.
      .description Your order may not be fulfilled by the brand if the Minimum Order Value is not met.

  .items
    .item(v-for="i, k in unreached" :key="k")
      .brand.pf-ellipsis(v-text="i.title")
      .value.pf-nowrap
        span.current {{ i.total | cents }}
        span.divider /
        span.target {{ i.mov | cents }} MOV
      .actions
        .action(@click="addMoreCases(i)")
          i.bx.bxs-plus-circle
          span Add more cases
        nuxt-link.action(
          v-if="selectedCompany !== i.company"
          :to="$links.catalog(i.explore)") Explore SKUs
            span.hidden-sm-and-down &nbsp;from this brand
</template>

<script>
import { REGION_TYPES, LIMIT_TYPES } from '~/settings'

export default {
  computed: {
    unreached () {
      const groups = this.$store.getters['cart/groups']
      const pfd = groups?.[REGION_TYPES.PFD] || {}
      return (Object.values(pfd) || [])
        .filter(i => i.limitType === LIMIT_TYPES.MOV && !i.reach)
    },

    selectedCompany () {
      return +this.$route.query?.['q[vendor_company_id]']
    }
  },

  methods: {
    addMoreCases (group) {
      this.$workflow.showMovAlert({
        parent: this,
        mov: group,
        variant: group?.items?.[0],
        quantity: 0,
        added: 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mov-alert-headup {
  margin-top: 1.5rem;
  background: white;
  border: none;
  border-left: 4px solid $--color-warning;
  padding: 1rem 1rem 4px;
  border-radius: $--radius;
  box-shadow: $--box-shadow-modern;
  .header {
    display: flex;
    > * {
      min-width: 0;
    }
    .icon {
      flex: 0 36px;
      margin-right: 1em;
      margin-top: .3em;
      i {
        color: $--color-warning;
        font-size: 36px;
        width: 36px;
        height: 36px;
        border-radius: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .info {
      flex: 1;
      .title {
        font-weight: $--font-weight-bold;
        font-size: 16px;
      }
      .description {
        color: $--color-text-secondary;
        margin-top: 4px;
        font-size: 13px;
      }
    }
  }

  .items {
    display: grid;
    margin-top: 1.5em;
    font-size: 13px;
    > .item {
      padding: 8px 0;
      font-size: 13px;
      border-top: $--border-light;
      display: grid;
      grid-gap: .25em;
      @include media(lg) {
        grid-template-columns: 1fr 1fr 330px;
        grid-gap: 1em;
      }
      > * {
        min-width: 0;
      }
      .value {
        display: flex;
        font-weight: $--font-weight-bold;
        > * {
          min-width: 0;
        }
        span.current {
          color: $--color-warning;
        }
        span.divider {
          margin: 0 .5em;
        }
      }
      .actions {
        display: flex;
        align-items: center;
        @include media(lg) {
          flex: 0 360px;
        }
        > * {
          min-width: 0;
          display: flex;
          align-items: center;
          color: $--color-primary;
          cursor: pointer;
          &:not(:last-child) {
            border-right: $--border-light;
            padding-right: 1rem;
            margin-right: 1rem;
          }
          i {
            margin-right: .5em;
          }
        }
      }
    }
  }
}
</style>
